"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.receivedAdjustmentSchema = void 0;
exports.receivedAdjustmentSchema = {
    type: 'object',
    required: ['addedDate', 'amount'],
    properties: {
        addedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'Should be formatted as yyyy-mm-dd',
        },
        amount: {
            type: 'number',
            maximum: 99999999,
            minimum: -99999999,
            decimal: [10, 2],
            errorMessage: 'Should be a decimal with up to 10 digits in total and 2 digits of precision',
        },
    },
};
